import { useState, useEffect } from 'react';
import toast from 'react-hot-toast';


import { permisosAPI } from '../services/api';

const RolesPanel = () => {
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [matriz, setMatriz] = useState({});
    const [permisosDisponibles, setPermisosDisponibles] = useState([]);
    const [roles, setRoles] = useState([]);

    useEffect(() => {
        cargarPermisos();
    }, []);

    const cargarPermisos = async () => {
        setLoading(true);
        try {
            const res = await permisosAPI.getAll();
            const { matriz: m, permisosDisponibles: pd, roles: r } = res.data;
            setMatriz(m);
            setPermisosDisponibles(pd);
            setRoles(r);
        } catch (err) {
            toast.error('Error al cargar permisos: ' + err.message);
        } finally {
            setLoading(false);
        }
    };

    const togglePermiso = (rol, permiso) => {
        if (rol === 'superadmin') return; // no editable
        setMatriz(prev => ({
            ...prev,
            [rol]: {
                ...prev[rol],
                [permiso]: !prev[rol]?.[permiso]
            }
        }));
    };

    const guardarTodo = async () => {
        setSaving(true);
        try {
            const editableRoles = roles.filter(r => r !== 'superadmin');
            for (const rol of editableRoles) {
                await permisosAPI.update(rol, matriz[rol] || {});
            }
            toast.success('Permisos actualizados correctamente');
        } catch (err) {
            toast.error('Error: ' + err.message);
        } finally {
            setSaving(false);
        }
    };

    const rolLabel = (rol) => {
        const labels = {
            superadmin: 'Super Admin',
            admin: 'Admin',
            gestor_proyecto: 'Gestor de Proyectos',
            comercial: 'Comercial',
            personal: 'Personal'
        };
        return labels[rol] || rol;
    };

    if (loading) {
        return <div className="loading">Cargando permisos...</div>;
    }

    return (
        <div className="card">
            <div className="card-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px' }}>
                <h2>Roles y Permisos</h2>
            </div>
            <div className="admin-content">
                <p style={{ color: 'rgba(255,255,255,0.5)', marginBottom: '16px', fontSize: '0.9rem' }}>
                    Define qué acciones puede realizar cada rol. SuperAdmin siempre tiene todos los permisos.
                </p>

                <div className="tableWrap">
                    <table className="galTable">
                        <thead>
                            <tr>
                                <th style={{ minWidth: '220px' }}>Permiso</th>
                                {roles.map(rol => (
                                    <th key={rol} style={{ textAlign: 'center', minWidth: '120px' }}>
                                        {rolLabel(rol)}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {permisosDisponibles.map(p => (
                                <tr key={p.key}>
                                    <td>{p.label}</td>
                                    {roles.map(rol => (
                                        <td key={rol} style={{ textAlign: 'center' }}>
                                            <input
                                                type="checkbox"
                                                checked={rol === 'superadmin' ? true : !!matriz[rol]?.[p.key]}
                                                disabled={rol === 'superadmin'}
                                                onChange={() => togglePermiso(rol, p.key)}
                                                style={{
                                                    width: '18px',
                                                    height: '18px',
                                                    cursor: rol === 'superadmin' ? 'not-allowed' : 'pointer',
                                                    accentColor: '#8cdcff'
                                                }}
                                            />
                                        </td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div className="divider" />

                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <button
                        className="btn neon"
                        onClick={guardarTodo}
                        disabled={saving}
                    >
                        {saving ? 'Guardando...' : 'Guardar Permisos'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default RolesPanel;
